module.exports = __webpack_public_path__ + "static/media/ic-error.bdf7cb3c.svg";